import { colors } from '@/components/atoms/colors'
import MahimaLogo from '@/components/atoms/mahimaLogo'
import { motion } from 'framer-motion'
import Link from 'next/link'

const AnimationScroll = ({ scrolled, onAnimationComplete }) => {
  const base =
    'absolute bottom-0 left-1/2 -translate-x-1/2 w-full pointer-events-none aspect-[12/5] px-smallMobile md:px-mediumDesktop flex items-end z-[3]'
  return (
    <motion.div
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      transition={{
        duration: 0,
        delay: 3.2,
      }}
      onAnimationComplete={onAnimationComplete}
      id="logo"
      className={base}
    >
      <div className="relative w-full max-w-1440 mx-auto">
        <Link scroll={false} href="/">
          <MahimaLogo
            color={scrolled ? colors.olive : colors.dune}
            className="w-full h-full"
          />
        </Link>
      </div>
    </motion.div>
  )
}

export default AnimationScroll
